import React, { useState } from "react";
import MobileSidebar from "./MobileSidebar";
import "../../assets/custom-scss/landing.scss";
import Logo from "../../assets/images/landingpage/logo.png";
import brochure from "../../assets/images/landingpage/AZSM-Enterprises-HMS.pdf";

import {
    Home,
    Heart,
    Activity,
    FileText,
    Clipboard,
    Package,
    Droplet,
    BookOpen,
    Folder,
    UserCheck,
    Calendar,
    DollarSign,
    Box,
    BarChart2,
    Tag,
    Monitor,
    Database,
    Layers,
    Menu
} from "react-feather";

import TopHeader from "./TopHeader";

const Header = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const menus = [
        { title: "Home", link: "/home" },
        { title: "About Us", link: "#about" },

        { title: "Healthray Products", items: products },
        { title: "Speciality", items: speciality },
        { title: "Solutions", items: solutions },
        { title: "Contact", link: "#contactus" }

    ];

    return (
        <>
            <TopHeader />
            <header className="lanp-header bg-white border-bottom border-gray ">
                <div className="container">
                    <nav className="navbar navbar-expand-lg py-1 ">
                        <div className="container">

                            <a href="/" className="navbar-brand fw-bold">
                                <img src={Logo} alt="logo" className="logo-st" />
                            </a>
                            <button
                                className="navbar-toggler"
                                onClick={() => setSidebarOpen(true)}
                            >
                                <Menu />
                            </button>
                            <div className="collapse navbar-collapse">
                                <ul className="navbar-nav ms-auto">

                                    <li className="nav-item">
                                        <a href="/" className="nav-link fw-bold">Home</a>
                                    </li>

                                    <li className="nav-item">
                                        <a href="#about" className="nav-link fw-bold">About Us</a>
                                    </li>
                                    <li className="nav-item lanp-mega-parent">
                                        <a href="#" className="nav-link fw-bold">AZSM Products</a>

                                        <div className="lanp-mega-menu shadow p-4">
                                            <div className="container">
                                                <div className="row">

                                                    <div className="col-lg-8">
                                                        <div className="row">
                                                            {products.map((item, i) => (
                                                                <MegaItem key={i} item={item} />
                                                            ))}
                                                        </div>
                                                    </div>

                                                    <RightCard />
                                                </div>

                                                <MegaFooter />
                                            </div>
                                        </div>
                                    </li>

                                    <li className="nav-item lanp-mega-parent">
                                        <a href="#" className="nav-link fw-bold">Speciality</a>

                                        <div className="lanp-mega-menu shadow p-4">
                                            <div className="container">
                                                <div className="row">
                                                    {speciality.map((item, i) => (
                                                        <MegaItem key={i} item={item} />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </li>

                                    <li className="nav-item lanp-mega-parent">
                                        <a href="#" className="nav-link fw-bold">Solutions</a>

                                        <div className="lanp-mega-menu shadow p-4">
                                            <div className="container">
                                                <div className="row">
                                                    {solutions.map((item, i) => (
                                                        <MegaItem key={i} item={item} />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </li>

                                    <li className="nav-item">
                                        <a href="#contactus" className="nav-link fw-bold">Contact Us</a>
                                    </li>

                                    <li className="nav-item ms-2">
                                        <a href="/book-demo" className="btn btn-primary lanp-btn-primary py-2 rounded-pill">
                                            Book A Demo
                                        </a>
                                    </li>
                                    <li className="nav-item ms-2">
                                        <a href="/login" className="btn btn-primary lanp-btn-primary py-2 rounded-pill">
                                            Login
                                        </a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </nav>
                </div>

                <MobileSidebar
                    isOpen={sidebarOpen}
                    onClose={() => setSidebarOpen(false)}
                    menus={menus}
                />
            </header>
        </>
    );
};


const MegaItem = ({ item }) => {
    const Icon = item.icon;

    return (
        <div className="col-md-6 mb-3">
            <a
                href={item.path}
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none text-dark"
            >
                <div className="lanp-mega-item d-flex">
                    <div className="lanp-icon me-3">
                        {Icon && <Icon size={20} />}
                    </div>
                    <div>
                        <h6 className="fw-bold mb-1">{item.title}</h6>
                        <p className="small text-muted mb-0">{item.desc}</p>
                    </div>
                </div>
            </a>
        </div>
    );
};

const RightCard = () => (
    <div className="col-lg-4">
        <div className="lanp-mega-card p-4 h-100">
            <h5 className="fw-bold">
                Transform Your Practice With Smart Tools
            </h5>
            <p className="small">
                Discover all-in-one healthcare solutions designed to make
                processes simpler and faster.
            </p>
            <a href="/book-demo" className="btn btn-primary btn-sm lanp-btn-primary rounded-pill">
                Explore Products
            </a>
        </div>
    </div>
);

const MegaFooter = () => (
    <div className="lanp-mega-footer d-flex justify-content-between align-items-center mt-3">
        <span>Have a look at our one-stop digital healthcare solution</span>
        <div>
            <a href="/book-demo" className="btn btn-light btn-sm me-2 rounded-pill">Book A Demo</a>
            <a href={brochure}
                target="_blank"
                rel="noopener noreferrer" className="btn btn-light btn-sm rounded-pill">Brochure</a>
        </div>
    </div>
);


const products = [
    { title: "Hospital Information Management", desc: "AI hospital solution", icon: Home, path: "/book-demo" },
    { title: "EMR Software", desc: "Clinical efficiency", icon: FileText, path: "/book-demo" },
    { title: "EHR Software", desc: "Manage patient data", icon: Clipboard, path: "/book-demo" },
    { title: "Pharmacy Management System", desc: "Reduce costs", icon: Package, path: "/book-demo" },
    { title: "LIMS", desc: "Lab operations", icon: Droplet, path: "/book-demo" },
    { title: "Clinic Management Software", desc: "Boost success", icon: Heart, path: "/book-demo" },
];

const speciality = [
    { title: "Custom Software Development", desc: "Tailored software solutions", icon: Tag, path: "/book-demo" },
    { title: "Healthcare Software Solutions", desc: "Smart healthcare systems", icon: Heart, path: "/book-demo" },
    { title: "Web & Mobile Applications", desc: "Apps for all devices", icon: Monitor, path: "/book-demo" },
    { title: "CRM Systems", desc: "Manage customer data", icon: Layers, path: "/book-demo" },
    { title: "Digital Transformation", desc: "Shift to digital processes", icon: Database, path: "/book-demo" },
    { title: "System Integration", desc: "Connect multiple systems", icon: Activity, path: "/book-demo" },
];
const solutions = [
    {
        icon: UserCheck,
        title: "Patient Management",
        desc: "Manage patient records easily.",
        path: "/book-demo"
    },
    {
        icon: Calendar,
        title: "Appointment Scheduling",
        desc: "Automate bookings and reduce wait times.",
        path: "/book-demo"
    },
    {
        icon: Folder,
        title: "Electronic Medical Records",
        desc: "Secure and quick access to records.",
        path: "/book-demo"
    },
    {
        icon: DollarSign,
        title: "Billing & Finance",
        desc: "Accurate billing and financial tracking.",
        path: "/book-demo"
    },
    {
        icon: Box,
        title: "Inventory Management",
        desc: "Track and manage medical supplies.",
        path: "/book-demo"
    },
    {
        icon: BarChart2,
        title: "Reports & Analytics",
        desc: "Real-time insights and reports.",
        path: "/book-demo"
    },

    {
        icon: Folder,
        title: "Case Studies",
        desc: "Real success stories.",
        path: "/book-demo"
    }
];

export default Header;